import { useCallback, useEffect, useState } from 'react'
import { supabaseGetter } from '~/api/supabase-getter'

export const useFarmList = () => {
  const [farmList, setFarmList] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [refetchTrigger, setRefetchTrigger] = useState(0)

  useEffect(() => {
    async function fetchFarmList() {
      try {
        setLoading(true)
        setError(null)

        const { data, error: fetchError } = await supabaseGetter.organizations.getFarms()

        if (fetchError) {
          console.warn('Error fetching farm list:', fetchError)
          setError(fetchError.message || 'Failed to fetch farm list')
          setFarmList([])
        } else if (data) {
          setFarmList(data)
        }
      } catch (err) {
        console.warn('Error in fetchFarmList:', err)
        setError('An unexpected error occurred')
        setFarmList([])
      } finally {
        setLoading(false)
      }
    }

    fetchFarmList()
  }, [refetchTrigger])

  const refetch = useCallback(() => {
    supabaseGetter.organizations.invalidate()
    setRefetchTrigger(prev => prev + 1)
  }, [])

  return {
    farmList,
    loading,
    error,
    refetch,
    invalidate: supabaseGetter.organizations.invalidate
  }
}